import Subscription from "../views/subscription/subscriptions";
import RecurrencePlan from "../views/subscription/recurrencePlan";
import PaymentLink from "../views/subscription/paymentLink";

import SubscriptionsIcon from "../assets/icons/subscription.svg";
import SubscriptionsIconHover from "../assets/icons/subscriptionHover.svg";
import RecurrenceIcon from "../assets/icons/recurrence.svg";
import RecurrenceIconHover from "../assets/icons/recurrenceHover.svg";
import PaperClip from "../assets/icons/link.svg";
import PaperClipHover from "../assets/icons/linkHover.svg";

const routesSubscription = [
    {
        id: "cm5a2",
        path: "/recurrence-plan",
        name: "Plano de Recorrências",
        icon: RecurrenceIcon,
        iconHover: RecurrenceIconHover,
        layout: "/subscription",
        component: RecurrencePlan,
        redirect: false,
    },
    
    {
        id: "cm5a1",
        path: "/subscriptions",
        name: "Assinaturas",
        icon: SubscriptionsIcon,
        iconHover: SubscriptionsIconHover,
        layout: "/subscription",
        component: Subscription,
        redirect: false,
    },
    
    {
        id: "cm5a3",
        path: "/payment-link",
        name: "Link de Pagamento",
        icon: PaperClip,
        iconHover: PaperClipHover,
        layout: "/subscription",
        component: PaymentLink,
        redirect: false,
    },
]

export default routesSubscription;